import request from '@/shared/api/request';

export const powerOnDatabase = (uuid: string): Promise<void> =>
  request({
    url: `/databases/${uuid}/`,
    method: 'POST',
    data: { action: 'power_on' },
  });
